import { render, staticRenderFns } from "./SignHeroDialog.vue?vue&type=template&id=e51e2e58&scoped=true"
import script from "./SignHeroDialog.vue?vue&type=script&lang=js"
export * from "./SignHeroDialog.vue?vue&type=script&lang=js"
import style0 from "./SignHeroDialog.vue?vue&type=style&index=0&id=e51e2e58&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51e2e58",
  null
  
)

export default component.exports